import { jsx } from '@emotion/react';
import React, { useMemo } from 'react';
import { SxProp } from '../style/sxProp';
import useTheme from '../style/useTheme';

export type BoxProps<T extends keyof JSX.IntrinsicElements = 'div'> = {
  as?: T;
  sx?: SxProp;
  children?: React.ReactNode;
} & JSX.IntrinsicElements[T];

const Box = <T extends keyof JSX.IntrinsicElements>({
  children,
  sx,
  as = 'div' as T,
  ...elProps
}: BoxProps<T>): React.ReactElement => {
  const { resolveCSS } = useTheme();
  const css = useMemo(() => resolveCSS(sx), [sx, resolveCSS]);
  return jsx(
    as,
    {
      ...elProps,
      css,
    },
    children
  );
};

export default Box;
